import { Injectable, signal } from '@angular/core'
import { ContentUnitNavigationItem } from '@app/layout/sidebar/models/content-unit-navigation-item.model'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class TemplateSidebarBridgeService {
  public readonly isTemplateEditMode = signal(false)
  public readonly usedContentUnitUuids = signal<string[]>([])
  private readonly addContentUnitSource = new Subject<ContentUnitNavigationItem>()
  public readonly addContentUnit$ = this.addContentUnitSource.asObservable()

  public addContentUnit(cu: ContentUnitNavigationItem): void {
    this.addContentUnitSource.next(cu)
  }

  public removeContentUnit(uuid: string): void {
    this.usedContentUnitUuids.update(uuids => uuids.filter(u => u !== uuid))
  }
}
